<template lang="html">
  <div>
    <hr />
    <h5 class="mb-3">
      You are currently subscribed to an individual plan
    </h5>
    <p>
      <b>Plan level:</b>
      {{ planNameFromId(user_doc.subscribed_paypal_plan) }}
      <v-icon
        v-if="user_doc.subscribed_paypal_plan == plan.plan_id"
        name="check-circle"
        class="ml-1"
        style="color: green"
      />
    </p>
    <div v-if="user_doc.paypal_summary.paypal_remaining_days < 0">
      <p v-if="user_doc.paypal_summary.paypal_plan_interval == 'month'">
        Your monthly membership started on
        {{
          user_doc.paypal_summary.paypal_start_date_dt.seconds
            | date_string_short
        }}.
      </p>
      <p v-else>
        Your annual membership started on
        {{
          user_doc.paypal_summary.paypal_start_date_dt.seconds
            | date_string_short
        }}.
      </p>
    </div>
    <div v-else>
      <p v-if="user_doc.paypal_summary.paypal_plan_interval == 'month'">
        Your current monthly membership is valid through
        {{
          user_doc.paypal_summary.paypal_current_period_end_dt.seconds
            | date_string_short
        }}.
      </p>
      <p v-else>
        Your annual membership is valid through
        {{
          user_doc.paypal_summary.paypal_current_period_end_dt.seconds
            | date_string_short
        }}.
      </p>
    </div>

    <div v-if="user_doc.paypal_result.state == 'Cancelled'">
      <p v-if="amount">
        Amount:
        {{ amount.value }}
        {{ amount.currency }}
      </p>
      <p>
        <v-icon name="exclamation-triangle" class="mr-2" />Renewal has been
        cancelled for your account.
      </p>
    </div>
    <div v-if="user_doc.paypal_result.state == 'Active'">
      <p v-if="amount">
        Renewal:
        {{ amount.value }}
        {{ amount.currency }}
      </p>
      <p class="small">
        Renewal can be managed via your PayPal account.
      </p>
    </div>

    <div>
      <h5>Payment history</h5>
      <p>
        Your most recent transaction was on
        {{
          user_doc.paypal_summary.paypal_start_date_dt.seconds
            | date_string_short
        }}.
      </p>
      <p>
        <b-btn
          size="sm"
          variant="secondary"
          :to="{
            name: 'account-latest-transaction',
            params: { version: 'receipt' }
          }"
          class="mr-1"
        >
          View receipt
        </b-btn>
        <b-btn
          size="sm"
          variant="outline-secondary"
          :to="{
            name: 'account-latest-transaction',
            params: { version: 'invoice' }
          }"
        >
          View invoice
        </b-btn>
      </p>
      <p class="small">
        For a full list of your transactions, please see your PayPal account.
      </p>
    </div>
  </div>
</template>

<script>
import find from "lodash/find";
import { format } from "date-fns";
import { plans } from "@/defaults";
export default {
  name: "PayPalDetails",
  filters: {
    date_string_short: function(value) {
      value = value * 1000;
      return format(new Date(value), "MMMM d, yyyy");
    }
  },
  computed: {
    user_doc() {
      return this.$store.state.user_doc;
    },
    plan() {
      return this.$store.getters.user_plan;
    },
    amount() {
      try {
        return this.user_doc.paypal_result.plan.payment_definitions[0].amount;
      } catch {
        return null;
      }
    }
  },
  methods: {
    planNameFromId(plan_id) {
      return find(plans, { plan_id: plan_id }).name;
    }
  }
};
</script>

<style lang="css" scoped></style>
